// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"styles_Breadcrumbs__1xzN2","Breadcrumbs--default":"styles_Breadcrumbs--default__1_2nV","Breadcrumbs-item":"styles_Breadcrumbs-item__3s9JJ"};